import React from 'react'

import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog'
import { Text } from '@wartek-id/text'
import { Button } from '@wartek-id/button'

import type { ConfirmNavigateAwayDialogProps } from 'types/microlearning'

import CheckmarkIcon from 'assets/icons/checkmark-alt.svg'

interface QuizDoneDialogProps extends ConfirmNavigateAwayDialogProps {
  canDoRefleksi?: boolean
  refleksiIsDone?: boolean
}

const QuizDoneDialog = ({
  isOpen,
  onClose,
  onConfirmed,
  canDoRefleksi = false,
  refleksiIsDone = false,
}: QuizDoneDialogProps) => {
  return (
    <Dialog isOpen={isOpen} onClose={onClose}>
      <DialogOverlay />
      <DialogContent>
        <section className="p-3">
          <div className="w-full mb-6">
            <div className="flex items-center justify-center mx-auto w-14 h-14 rounded-full bg-[#4CA375]">
              <CheckmarkIcon />
            </div>
          </div>
          <div className="mb-2 text-center">
            <Text variant="heading-sm">Selamat! Latihan Pemahaman Selesai</Text>
          </div>
          <div className="mb-6 text-center">
            {!canDoRefleksi && (
              <Text>
                Silakan pelajari konten yang ada di aktivitas terlebih dahulu
                agar Anda dapat mengisi refleksi
              </Text>
            )}
            {canDoRefleksi && !refleksiIsDone && (
              <Text>
                Selanjutnya, silakan isi refleksi untuk menyelesaikan materi ini
              </Text>
            )}
            {canDoRefleksi && refleksiIsDone && (
              <Text>
                Anda telah menyelesaikan semua aktivitas untuk materi ini.
                Silakan pilih materi lain untuk dipelajari.
              </Text>
            )}
          </div>
          <div>
            <Button
              fullWidth
              size="lg"
              color={refleksiIsDone || !canDoRefleksi ? 'black' : 'white'}
              onClick={onConfirmed}
            >
              Kembali ke Materi
            </Button>
          </div>
        </section>
      </DialogContent>
    </Dialog>
  )
}

export default QuizDoneDialog
